module.exports = __webpack_public_path__ + "media/images/bg_reviews-29e5e5da12301ba7770a9b0c660b52a4.svg";